export enum SCROLL_DIRECTION {
  LEFT = 'left',
  RIGHT = 'right',
}
